<template lang="pug">
    div(class="p-3 pb-4")
        div(
            v-if="error.statusCode === 404"
            class="flex justify-evenly items-center my-6 lg:container"
        )
            div(class="text-center text-gray" style="max-width: 650px;")
                div(class="font-bold text-3xl") 404. Page Not Found.
                p(class="text-2xl") We're sorry, it looks like the page you're looking for has come to a dead end.
                h5 Let us help you find something else or head #[nuxt-link(:to="{ name: 'home' }") back home!]
            div(class="hidden md:block")
                img(:src="errorImage")
        template(v-else)
            h1 {{ h1 }}
            | {{ text }}
</template>

<script>
export default {
    name: 'Error',
    // eslint-disable-next-line vue/require-prop-types
    props: ['error'],
    head() {
        return this.$metaHelpers
            .generateMetas({ title: `${this.h1} [TITLE_SUFFIX]` }, this.$route)
            .setIsNoIndex()
            .format()
    },
    computed: {
        h1() {
            return this.error.statusCode === 404 ? 'Not Found' : 'Internal Error'
        },
        text() {
            return this.error.statusCode === 404
                ? 'The page you requested does not exist'
                : this.error.message
        },
        errorImage() {
            return this.$getAssetUrl(this.$config.runtime.theme.errorPage.image)
        },
    },
    mounted() {
        this.$uiEvents.$emit('errorPageViewed', this.$route.fullPath, this.error.statusCode)
        this.$store.commit('setIs404', true)
    },
    destroyed() {
        this.$store.commit('setIs404', false)
    },
}
</script>
